/* eslint-disable max-len */
import axios from 'axios';
import { store } from 'store';
import { ENDPOINTS } from './endpoints';

let API;

if (process.env.NODE_ENV === 'development') {
  API = axios.create({
    baseURL: `http://${process.env.REACT_APP_SERVICES_USER_ADDRESS}:${process.env.REACT_APP_SERVICES_USER_PORT}/`,
  });
} else {
  API = axios.create({
    baseURL: `${process.env.REACT_APP_FRONTEND_URL}/user/`,
  });
}

API.interceptors.request.use(
  (config) => {
    const { isOnline } = store.getState().platform;

    if (!isOnline) {
      return Promise.reject(
        new axios.Cancel('Request blocked: No Internet Connection')
      );
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const deleteProfilePicture = (token) =>
  API.delete(ENDPOINTS.delete_user_image, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const deleteUserAccount = (token) => API.delete(ENDPOINTS.delete_user_account, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

const followUser = (payload, token) =>
  API.post(ENDPOINTS.follow_user, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const getUserIP = () => API.get(ENDPOINTS.get_user_ip);

const getProductRecommendation = (categoryCode, token) =>
  API.get(ENDPOINTS.get_product_recommendation(categoryCode), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const getUserReviews = (page, size, token) =>
  API.get(ENDPOINTS.get_reviews_for_loggedin_user(page, size), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const getProductsUpvotedByUser = (page, size, token) =>
  API.get(ENDPOINTS.get_product_liked_for_loggedin_user(page, size), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const gerUserProfileData = (page, size, token, username) =>
  API.get(ENDPOINTS.get_profile_data_by_username(page, size, username), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const reportUser = (payload, token) =>
  API.post(ENDPOINTS.report_user, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const setUserPreference = (payload, token) =>
  API.post(ENDPOINTS.set_user_preference, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const updateOAuthMoreDetails = (payload, token) => {
  const config = {};

  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  return API.put(ENDPOINTS.update_oauth_more_details, payload, config);
};


const uploadProfilePicture = (token, payload) =>
  API.post(ENDPOINTS.upload_user_image, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });

const getUserPreference = (token, categoryCode) => API.get(ENDPOINTS.get_user_preference(categoryCode), {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export {
  deleteProfilePicture,
  deleteUserAccount,
  followUser,
  getUserIP,
  getUserReviews,
  getProductsUpvotedByUser,
  getUserPreference,
  gerUserProfileData,
  getProductRecommendation,
  reportUser,
  setUserPreference,
  updateOAuthMoreDetails,
  uploadProfilePicture,
};
